import Hero from '../hero/Hero'
import React from "react"

export default (props) => (
    <Hero bckgrdImage={props.bckgrdImage}>
      <h1 className="headline"><span className="bold700">VASCEPA dosing</span></h1>
    </Hero>
) 